import * as types from '@/store/mutation-types'
// 设置token
export const setToken = ({ commit }, token) => {
  commit(types.SET_TOKEN, token)
}
// 退出登录
export const loginOut = ({ commit }) => {
  commit(types.CLEAR_TOKEN)
}
